export default function Intro() {
  return (
    <section className="relative bg-background-50 py-20 md:py-32 px-6 md:px-16 lg:px-24 overflow-hidden">
      {/* Decorative circle */}
      <div className="absolute -right-32 -top-32 w-[500px] h-[500px] rounded-full bg-primary-50/60 blur-3xl pointer-events-none"></div>
      <div className="absolute -left-24 bottom-0 w-[400px] h-[400px] rounded-full bg-accent-50/40 blur-3xl pointer-events-none"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Immaculately%20clean%20bright%20Japanese%20modern%20living%20room%20interior%20after%20professional%20house%20cleaning%20service%2C%20sparkling%20polished%20wooden%20floor%20reflecting%20soft%20natural%20sunlight%20from%20large%20window%2C%20neutral%20beige%20white%20cream%20walls%2C%20minimalist%20furniture%20arrangement%20with%20light%20oak%20tones%2C%20fresh%20and%20airy%20atmosphere%2C%20no%20people%2C%20pristine%20and%20spotless%20surfaces%2C%20warm%20ambient%20lighting%2C%20professional%20real%20estate%20interior%20photography%20style%2C%20crisp%20details%2C%20serene%20domestic%20space%2C%20subtle%20natural%20shadows%20across%20the%20clean%20floor&width=800&height=1000&seq=intro-cleaning-2026-02&orientation=portrait"
                alt="ハウスクリーニング施工後の室内"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 md:-bottom-8 md:-right-8 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-2xl p-5 md:p-7 w-40 md:w-52">
              <div className="font-heading text-3xl md:text-4xl font-bold leading-none">最短翌週</div>
              <div className="text-xs md:text-sm mt-2 tracking-wider opacity-90">お見積りから
　　　　　施工まで</div>
            </div>
            <div className="absolute -top-4 -left-4 bg-background-50 border border-background-200/70 rounded-full px-4 py-2 flex items-center gap-2">
              <i className="ri-home-smile-line text-primary-500"></i>
              <span className="text-xs font-medium text-foreground-800">ハウスクリーニング</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="w-10 h-px bg-primary-500"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-primary-700 font-medium">About Wind</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6 md:mb-8">
            心地いい住まいに、<br />
            <span className="text-primary-600">最良の風</span>を吹き込む。
          </h2>
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-5">
            株式会社Windは、東京都・神奈川県を中心に、
            原状回復工事・内装リフォーム・ハウスクリーニングを総合的に手掛けています。
          </p>
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-8">
            「速さ」と「丁寧さ」は、両立できる。<br />
            私たちは地域の管理会社・オーナー様の困りごとに、最短で寄り添うチームです。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {[
              { icon: "ri-flashlight-line", title: "スピード対応", desc: "最短翌週でお見積り" },
              { icon: "ri-shield-check-line", title: "確かな品質", desc: "経験豊富な職人が対応" },
              { icon: "ri-map-pin-line", title: "地域密着", desc: "オーナー様と長期パートナー" },
            ].map((item) => (
              <div
                key={item.title}
                className="p-5 rounded-xl bg-background-100/70 border border-background-200/70 hover:border-primary-300 transition-colors"
              >
                <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-primary-700 text-xl`}></i>
                </span>
                <div className="text-sm font-bold text-foreground-950 mb-1">{item.title}</div>
                <div className="text-xs text-foreground-600">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}